import React, { createContext, PropsWithChildren } from 'react';
import { LouiseOffer } from '../../../../../../../types/Quotes';
import { QuoteSpecifications } from '../../../../store/redux/slices/offersSlice';
import { ProductInfoAndContent } from '../../api/getProducts';

interface SingleOfferState {
  offer: LouiseOffer;
  productContent: ProductInfoAndContent;
  quoteSpecs: QuoteSpecifications;
  setQuoteSpecs: (quoteSpecs: QuoteSpecifications) => void;
  selectedGuarantees?: string[];
  setSelectedGuarantees?: (selectedGuarantees: string[]) => void;
  fetchQuote: () => void;
  isFetching: boolean;
}

export const SingleOfferStateContext = createContext<
  SingleOfferState | undefined
>(undefined);

/** This is used to easily provide the current product content inside any of the children of a product offer */
const SingleOfferStateProvider: React.FC<
  PropsWithChildren<SingleOfferState>
> = ({
  offer,
  productContent,
  quoteSpecs,
  setQuoteSpecs,
  selectedGuarantees,
  setSelectedGuarantees,
  fetchQuote,
  isFetching,
  children,
}) => {
  return (
    <SingleOfferStateContext.Provider
      value={{
        offer,
        productContent,
        quoteSpecs,
        setQuoteSpecs,
        selectedGuarantees,
        setSelectedGuarantees,
        fetchQuote,
        isFetching,
      }}
    >
      {children}
    </SingleOfferStateContext.Provider>
  );
};

export default SingleOfferStateProvider;
